
export type percent = number;
export type address = string;
export type base64 = string;
export enum DeBotCodeStatus {
  Unchanged = 0,
  Changed = 1
}

export interface FormGroupProps {
  disabled?: boolean,
  className?: string,
  label?: string,
  error?: string | boolean,
  theme?: any
}

export type Debot = {
  title: string,
  name: string,
  address: address,
}
export type Info = {
  totalTokens: string,
  totalEvers: string,
  totalUSD: string,
  totalOrders: string,
  everPrice: string,
  usdPrice: string,
  minOrderAmount: string
}
export type DebotInfo = {
  name: string,
  version: string,
  publisher: string,
  caption: string,
  author: string,
  support: string,
  hello: string,
  language: string,
  icon: base64
}
export type BundleItem = {
  addr: address,
  info: DebotInfo,
  codeStatus: DeBotCodeStatus 
}
